// // src/app/modules/Incidents/pages/IncidentDetail.jsx
// import React, { useEffect, useState } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import { shallowEqual, useSelector, useDispatch } from "react-redux";
// import * as actions from "../../Dashbord/_redux/dashboard/Actions";
// import {
//   ArrowLeft, AlertTriangle, MapPin, User, Clock,
//   CheckCircle, XCircle, Radio, Shield, Zap, Activity,
//   ChevronRight, RefreshCw, FileText, Phone, Hash,
//   Calendar, Tag, Navigation, Users,
// } from 'lucide-react';
// import Moment from "moment";
// import './incident-detail.scss';

// // ── Helpers ───────────────────────────────────────────────────────────────────

// const getDate    = (row) => row?.createdAt || row?.created_at;
// const getType    = (row) => row?.category  || row?.type || 'other';
// const getSubject = (row) => row?.subject?.name || (row?.reported_by !== 'anonymous' ? row?.reported_by : null);

// const fmt = (d) => d ? Moment(d).format('MMM DD, YYYY') : '—';
// const fmtFull = (d) => d ? Moment(d).format('MMM DD, YYYY · HH:mm') : '—';
// const fromNow = (d) => d ? Moment(d).fromNow() : '—';

// const SEVERITY_CFG = {
//   critical: { cls: 'sev--critical', label: 'Critical' },
//   high:     { cls: 'sev--high',     label: 'High' },
//   medium:   { cls: 'sev--medium',   label: 'Medium' },
//   low:      { cls: 'sev--low',      label: 'Low' },
// };

// const STATUS_CFG = {
//   // New schema
//   created:       { cls: 'sta--active',     label: 'Created',      icon: Radio },
//   dispatching:   { cls: 'sta--active',     label: 'Dispatching',  icon: Radio },
//   assigned:      { cls: 'sta--progress',   label: 'Assigned',     icon: Navigation },
//   responding:    { cls: 'sta--progress',   label: 'Responding',   icon: Navigation },
//   on_scene:      { cls: 'sta--progress',   label: 'On Scene',     icon: Shield },
//   escalated:     { cls: 'sta--escalated',  label: 'Escalated',    icon: AlertTriangle },
//   unresponsive:  { cls: 'sta--escalated',  label: 'Unresponsive', icon: AlertTriangle },
//   resolved:      { cls: 'sta--resolved',   label: 'Resolved',     icon: CheckCircle },
//   cancelled:     { cls: 'sta--cancelled',  label: 'Cancelled',    icon: XCircle },
//   // Old schema
//   active:        { cls: 'sta--active',     label: 'Active',       icon: Radio },
//   investigating: { cls: 'sta--progress',   label: 'Investigating',icon: Shield },
//   false_alarm:   { cls: 'sta--cancelled',  label: 'False Alarm',  icon: XCircle },
// };

// const TYPE_ICONS = {
//   sos: '🆘', vehicle: '🚗', location_threat: '📍',
//   medical: '🚑', fire: '🔥', crime: '🚨',
//   accident: '🚗', security_threat: '⚠️', other: '📋',
// };

// const TIMELINE_ICONS = {
//   created:            Radio,
//   dispatched:         Zap,
//   responder_assigned: Users,
//   status_change:      Activity,
//   escalated:          AlertTriangle,
//   note_added:         FileText,
//   resolved:           CheckCircle,
//   cancelled:          XCircle,
//   unresponsive:       AlertTriangle,
// };

// // ── Sub-components ────────────────────────────────────────────────────────────

// function MetaItem({ icon: Icon, label, value, highlight }) {
//   if (!value) return null;
//   return (
//     <div className={`det-meta-item ${highlight ? 'det-meta-item--highlight' : ''}`}>
//       <Icon size={13} className="det-meta-item__icon" />
//       <div>
//         <div className="det-meta-item__label">{label}</div>
//         <div className="det-meta-item__value">{value}</div>
//       </div>
//     </div>
//   );
// }

// function Section({ title, children, action }) {
//   return (
//     <div className="det-section">
//       <div className="det-section__head">
//         <span className="det-section__title">{title}</span>
//         {action}
//       </div>
//       <div className="det-section__body">
//         {children}
//       </div>
//     </div>
//   );
// }

// // ── Timeline ──────────────────────────────────────────────────────────────────

// function Timeline({ events = [] }) {
//   if (!events.length) {
//     return (
//       <div className="det-empty">
//         <Activity size={20} />
//         <p>No timeline events yet</p>
//       </div>
//     );
//   }

//   return (
//     <div className="det-timeline">
//       {events.map((ev, i) => {
//         const Icon = TIMELINE_ICONS[ev.event] || Activity;
//         const isLast = i === events.length - 1;
//         return (
//           <div key={i} className={`det-tl-item ${isLast ? 'det-tl-item--last' : ''}`}>
//             <div className="det-tl-item__track">
//               <div className="det-tl-item__dot">
//                 <Icon size={11} />
//               </div>
//               {!isLast && <div className="det-tl-item__line" />}
//             </div>
//             <div className="det-tl-item__content">
//               <div className="det-tl-item__top">
//                 <span className="det-tl-item__event">
//                   {ev.event?.replace(/_/g, ' ')}
//                 </span>
//                 {ev.to_status && (
//                   <span className="det-tl-item__arrow">
//                     → <span className="det-tl-item__status">{ev.to_status}</span>
//                   </span>
//                 )}
//                 <span className="det-tl-item__time">{fromNow(ev.timestamp)}</span>
//               </div>
//               {ev.message && (
//                 <div className="det-tl-item__msg">{ev.message}</div>
//               )}
//               <div className="det-tl-item__meta">
//                 {ev.actor_type && <span className="det-tl-pill">{ev.actor_type}</span>}
//                 {ev.timestamp  && <span className="det-tl-date">{fmtFull(ev.timestamp)}</span>}
//               </div>
//             </div>
//           </div>
//         );
//       })}
//     </div>
//   );
// }

// // ── Responders list (old schema) ──────────────────────────────────────────────

// function Responders({ responders = [] }) {
//   if (!responders.length) {
//     return (
//       <div className="det-empty">
//         <Users size={20} />
//         <p>No responders assigned</p>
//       </div>
//     );
//   }

//   return (
//     <div className="det-responders">
//       {responders.map((r, i) => (
//         <div key={i} className="det-responder-row">
//           <div className="det-responder-row__avatar">
//             <User size={15} />
//           </div>
//           <div className="det-responder-row__info">
//             <div className="det-responder-row__id">{r.user_id || r.responder_id}</div>
//             <div className="det-responder-row__meta">
//               {r.status && <span className="det-tl-pill">{r.status}</span>}
//               {r.responded_at && (
//                 <span className="det-tl-date">{fmtFull(r.responded_at)}</span>
//               )}
//             </div>
//           </div>
//           {r.eta_seconds && (
//             <div className="det-responder-row__eta">ETA {Math.round(r.eta_seconds / 60)}m</div>
//           )}
//         </div>
//       ))}
//     </div>
//   );
// }

// // ── SLA Strip ─────────────────────────────────────────────────────────────────

// function SlaStrip({ sla, createdAt }) {
//   if (!sla) return null;

//   const items = [
//     { label: 'Response',    val: sla.first_acceptance_seconds,  unit: 's' },
//     { label: 'On Scene',    val: sla.time_to_scene_seconds,     unit: 's' },
//     { label: 'Resolution',  val: sla.time_to_resolve_seconds,   unit: 's' },
//     { label: 'Escalations', val: sla.escalation_count,          unit: '' },
//   ].filter(i => i.val != null && i.val !== undefined);

//   if (!items.length) return null;

//   const fmtSecs = (s) => {
//     if (s < 60)   return `${s}s`;
//     if (s < 3600) return `${Math.round(s / 60)}m`;
//     return `${(s / 3600).toFixed(1)}h`;
//   };

//   return (
//     <div className="det-sla-strip">
//       {items.map((item, i) => (
//         <div key={i} className="det-sla-item">
//           <div className="det-sla-item__val">
//             {item.unit === 's' ? fmtSecs(item.val) : item.val}
//           </div>
//           <div className="det-sla-item__label">{item.label}</div>
//         </div>
//       ))}
//       {sla.resolution_met != null && (
//         <div className={`det-sla-item det-sla-item--badge ${sla.resolution_met ? 'det-sla-item--met' : 'det-sla-item--missed'}`}>
//           <div className="det-sla-item__val">
//             {sla.resolution_met ? '✓ Met' : '✗ Missed'}
//           </div>
//           <div className="det-sla-item__label">SLA</div>
//         </div>
//       )}
//     </div>
//   );
// }

// // ── Main page ─────────────────────────────────────────────────────────────────

// export function IncidentDetail() {
//   const { incidentId } = useParams();
//   const navigate       = useNavigate();
//   const dispatch       = useDispatch();

//   const { org, incidents, loading } = useSelector(
//     (state) => ({
//       org:       state.auth.organization,
//       incidents: state.dashboard.incidents,
//       loading:   state.dashboard.listLoading,
//     }),
//     shallowEqual
//   );

//   // Try to find from already-loaded list first, then fetch if needed
//   const [incident, setIncident] = useState(null);
//   const [fetching, setFetching] = useState(false);

//   useEffect(() => {
//     const fromCache = (incidents || []).find(
//       i => i.incident_id === incidentId || i._id === incidentId
//     );
//     if (fromCache) {
//       setIncident(fromCache);
//     } else {
//       setFetching(true);
//       dispatch(actions.fetchAllData('incident', org?.organization_id, { incidentId }));
//     }
//   }, [incidentId]);

//   useEffect(() => {
//     if (fetching && incidents?.length) {
//       const found = incidents.find(
//         i => i.incident_id === incidentId || i._id === incidentId
//       );
//       if (found) { setIncident(found); setFetching(false); }
//     }
//   }, [incidents, fetching]);

//   if (loading || fetching || !incident) {
//     return (
//       <div className="det-loading">
//         <RefreshCw size={22} className="det-spin" />
//         <span>Loading incident…</span>
//       </div>
//     );
//   }

//   const type       = getType(incident);
//   const statusCfg  = STATUS_CFG[incident.status] || STATUS_CFG.active;
//   const StatusIcon = statusCfg.icon;
//   const sevCfg     = SEVERITY_CFG[incident.severity] || SEVERITY_CFG.medium;
//   const createdAt  = getDate(incident);

//   // Timeline: prefer new schema `timeline` array, else build from `updates`
//   const timeline = incident.timeline?.length
//     ? incident.timeline
//     : (incident.updates || []).map(u => ({
//         event:     u.type || 'note_added',
//         message:   u.message,
//         actor_type: 'user',
//         actor_id:  u.user_id,
//         timestamp: u.timestamp,
//       }));

//   const responders = incident.dispatch_assignments?.length
//     ? incident.dispatch_assignments
//     : incident.responders || [];

//   return (
//     <div className="det-page">

//       {/* ── Top bar ───────────────────────────────────────────────────── */}
//       <div className="det-topbar">
//         <button className="det-back" onClick={() => navigate(-1)}>
//           <ArrowLeft size={16} /> Incidents
//         </button>

//         <div className="det-topbar__id">
//           <Hash size={13} />
//           <span className="det-topbar__id-val">{incident.incident_id || incident._id}</span>
//         </div>

//         <div className="det-topbar__badges">
//           <span className={`det-sev ${sevCfg.cls}`}>{sevCfg.label}</span>
//           <span className={`det-sta ${statusCfg.cls}`}>
//             <StatusIcon size={11} /> {statusCfg.label}
//           </span>
//         </div>
//       </div>

//       {/* ── Hero ──────────────────────────────────────────────────────── */}
//       <div className="det-hero">
//         <div className="det-hero__icon">
//           {TYPE_ICONS[type] || '📋'}
//         </div>
//         <div className="det-hero__text">
//           <h1 className="det-hero__title">{incident.title || 'Untitled Incident'}</h1>
//           <div className="det-hero__meta">
//             <span className="det-hero__type">{type.replace(/_/g, ' ')}</span>
//             <span className="det-hero__dot" />
//             <span className="det-hero__time">Reported {fromNow(createdAt)}</span>
//             {incident.is_drill && (
//               <><span className="det-hero__dot" /><span className="det-drill-badge">DRILL</span></>
//             )}
//           </div>
//           {incident.description && (
//             <p className="det-hero__desc">{incident.description}</p>
//           )}
//         </div>
//       </div>

//       {/* ── SLA strip ─────────────────────────────────────────────────── */}
//       <SlaStrip sla={incident.sla} createdAt={createdAt} />

//       {/* ── Body grid ─────────────────────────────────────────────────── */}
//       <div className="det-grid">

//         {/* Left column */}
//         <div className="det-col">

//           {/* Details */}
//           <Section title="Incident Details">
//             <div className="det-meta-grid">
//               <MetaItem icon={Calendar} label="Reported"     value={fmtFull(createdAt)} />
//               <MetaItem icon={Tag}      label="Category"     value={type.replace(/_/g, ' ')} />
//               <MetaItem icon={Shield}   label="Severity"     value={incident.severity?.toUpperCase()} />
//               <MetaItem icon={Activity} label="Status"       value={statusCfg.label} />
//               {incident.resolved_at && (
//                 <MetaItem icon={CheckCircle} label="Resolved At" value={fmtFull(incident.resolved_at)} highlight />
//               )}
//               {incident.cancelled_at && (
//                 <MetaItem icon={XCircle} label="Cancelled At" value={fmtFull(incident.cancelled_at)} />
//               )}
//               {incident.resolution_outcome && (
//                 <MetaItem icon={FileText} label="Outcome" value={incident.resolution_outcome.replace(/_/g, ' ')} />
//               )}
//             </div>
//             {incident.resolution_notes && (
//               <div className="det-notes">
//                 <div className="det-notes__label">Resolution Notes</div>
//                 <div className="det-notes__body">{incident.resolution_notes}</div>
//               </div>
//             )}
//           </Section>

//           {/* Subject (new schema) or Reporter (old schema) */}
//           {/* {(incident.subject || incident.reported_by) && (
//             <Section title={incident.subject ? 'Subject' : 'Reporter'}>
//               <div className="det-meta-grid">
//                 {incident.subject ? (
//                   <>
//                     <MetaItem icon={User}  label="Name"      value={incident.subject.name} />
//                     <MetaItem icon={Phone} label="Phone"     value={incident.subject.phone} />
//                     <MetaItem icon={Hash}  label="Reference" value={incident.subject.reference} />
//                   </>
//                 ) : (
//                   <MetaItem icon={User}  label="Reporter" value={incident.reported_by} />
//                 )}
//               </div>
//               {incident.subject?.metadata && Object.keys(incident.subject.metadata).length > 0 && (
//                 <div className="det-kv-list">
//                   {Object.entries(incident.subject.metadata).map(([k, v]) => (
//                     <div key={k} className="det-kv-row">
//                       <span className="det-kv-row__key">{k.replace(/_/g, ' ')}</span>
//                       <span className="det-kv-row__val">{v}</span>
//                     </div>
//                   ))}
//                 </div>
//               )}
//             </Section>
//           )} */}



//         {(incident.subject || incident.reporter || incident.reported_by) && (
//           <Section title={incident.subject ? 'Subject' : 'Reporter'}>
//             <div className="det-meta-grid">
//               {incident.subject ? (
//                 // Partner incident — subject object
//                 <>
//                   <MetaItem icon={User}  label="Name"      value={incident.subject.name} />
//                   <MetaItem icon={Phone} label="Phone"     value={incident.subject.phone} />
//                   <MetaItem icon={Hash}  label="Reference" value={incident.subject.reference} />
//                 </>
//               ) : incident.reporter ? (
//                 // Consumer incident — populated reporter
//                 <>
//                   <MetaItem icon={User}  label="Name"  value={incident.reporter.name} />
//                   <MetaItem icon={Phone} label="Phone" value={incident.reporter.phone} />
//                   <MetaItem icon={Hash}  label="Email" value={incident.reporter.email} />
//                 </>
//               ) : (
//                 // Fallback — just the ID (anonymous or unpopulated)
//                 <MetaItem icon={User} label="Reporter" value={
//                   incident.reported_by === 'anonymous' ? 'Anonymous' : incident.reported_by
//                 } />
//               )}
//             </div>

//             {/* Subject metadata map — partner only */}
//             {incident.subject?.metadata && Object.keys(incident.subject.metadata).length > 0 && (
//               <div className="det-kv-list">
//                 {Object.entries(incident.subject.metadata).map(([k, v]) => (
//                   <div key={k} className="det-kv-row">
//                     <span className="det-kv-row__key">{k.replace(/_/g, ' ')}</span>
//                     <span className="det-kv-row__val">{v}</span>
//                   </div>
//                 ))}
//               </div>
//             )}

//             {/* Click-to-call for consumer reporter */}
//             {incident.reporter?.phone && (
//               <a href={`tel:${incident.reporter.phone}`} className="det-map-link" style={{ marginTop: 12 }}>
//                 <Phone size={12} /> Call {incident.reporter.name || 'Reporter'} →
//               </a>
//             )}
//           </Section>
//         )}


//           {/* Location */}
//           {incident.location && (
//             <Section title="Location">
//               <div className="det-meta-grid">
//                 <MetaItem icon={MapPin}    label="Address"  value={incident.location.address} />
//                 <MetaItem icon={Navigation} label="Landmark" value={incident.location.landmark} />
//                 {incident.location.coordinates?.length === 2 && (
//                   <MetaItem
//                     icon={MapPin}
//                     label="Coordinates"
//                     value={`${incident.location.coordinates[1].toFixed(6)}, ${incident.location.coordinates[0].toFixed(6)}`}
//                   />
//                 )}
//               </div>
//               {incident.location.coordinates?.length === 2 && (
//                 <a
//                   className="det-map-link"
//                   href={`https://www.google.com/maps?q=${incident.location.coordinates[1]},${incident.location.coordinates[0]}`}
//                   target="_blank"
//                   rel="noreferrer"
//                 >
//                   <MapPin size={12} /> Open in Google Maps <ChevronRight size={12} />
//                 </a>
//               )}
//             </Section>
//           )}

//         </div>

//         {/* Right column */}
//         <div className="det-col">

//           {/* Timeline */}
//           <Section title="Timeline">
//             <Timeline events={timeline} />
//           </Section>

//           {/* Responders / Dispatch Assignments */}
//           {responders.length > 0 && (
//             <Section title={incident.dispatch_assignments?.length ? 'Dispatch Assignments' : 'Responders'}>
//               <Responders responders={responders} />
//             </Section>
//           )}

//         </div>
//       </div>
//     </div>
//   );
// }



// src/app/modules/Incidents/pages/IncidentDetail.jsx
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { shallowEqual, useSelector, useDispatch } from "react-redux";
import * as actions from "../../Dashbord/_redux/dashboard/Actions";
import {
  ArrowLeft, AlertTriangle, MapPin, User, Clock,
  CheckCircle, XCircle, Radio, Shield, Zap, Activity,
  ChevronRight, RefreshCw, FileText, Phone, Hash,
  Calendar, Tag, Navigation, Users,
} from 'lucide-react';
import Moment from "moment";
import './incident-detail.scss';

// ── Helpers ───────────────────────────────────────────────────────────────────

const getDate    = (row) => row?.createdAt || row?.created_at;
const getType    = (row) => row?.category  || row?.type || 'other';
const getSubject = (row) => row?.subject?.name || (row?.reported_by !== 'anonymous' ? row?.reported_by : null);

const fmt     = (d) => d ? Moment(d).format('MMM DD, YYYY') : '—';
const fmtFull = (d) => d ? Moment(d).format('MMM DD, YYYY · HH:mm') : '—';
const fromNow = (d) => d ? Moment(d).fromNow() : '—';

const SEVERITY_CFG = {
  critical: { cls: 'sev--critical', label: 'Critical' },
  high:     { cls: 'sev--high',     label: 'High' },
  medium:   { cls: 'sev--medium',   label: 'Medium' },
  low:      { cls: 'sev--low',      label: 'Low' },
};

const STATUS_CFG = {
  created:       { cls: 'sta--active',     label: 'Created',       icon: Radio },
  dispatching:   { cls: 'sta--active',     label: 'Dispatching',   icon: Radio },
  assigned:      { cls: 'sta--progress',   label: 'Assigned',      icon: Navigation },
  responding:    { cls: 'sta--progress',   label: 'Responding',    icon: Navigation },
  on_scene:      { cls: 'sta--progress',   label: 'On Scene',      icon: Shield },
  escalated:     { cls: 'sta--escalated',  label: 'Escalated',     icon: AlertTriangle },
  unresponsive:  { cls: 'sta--escalated',  label: 'Unresponsive',  icon: AlertTriangle },
  resolved:      { cls: 'sta--resolved',   label: 'Resolved',      icon: CheckCircle },
  cancelled:     { cls: 'sta--cancelled',  label: 'Cancelled',     icon: XCircle },
  active:        { cls: 'sta--active',     label: 'Active',        icon: Radio },
  investigating: { cls: 'sta--progress',   label: 'Investigating', icon: Shield },
  false_alarm:   { cls: 'sta--cancelled',  label: 'False Alarm',   icon: XCircle },
};

const TYPE_ICONS = {
  sos: '🆘', vehicle: '🚗', location_threat: '📍',
  medical: '🚑', fire: '🔥', crime: '🚨',
  accident: '🚗', security_threat: '⚠️', other: '📋',
};

const TIMELINE_ICONS = {
  created:            Radio,
  dispatched:         Zap,
  responder_assigned: Users,
  status_change:      Activity,
  escalated:          AlertTriangle,
  note_added:         FileText,
  resolved:           CheckCircle,
  cancelled:          XCircle,
  unresponsive:       AlertTriangle,
};

// ── Sub-components ────────────────────────────────────────────────────────────

function MetaItem({ icon: Icon, label, value, highlight }) {
  if (!value) return null;
  return (
    <div className={`det-meta-item ${highlight ? 'det-meta-item--highlight' : ''}`}>
      <Icon size={13} className="det-meta-item__icon" />
      <div>
        <div className="det-meta-item__label">{label}</div>
        <div className="det-meta-item__value">{value}</div>
      </div>
    </div>
  );
}

function Section({ title, children, action }) {
  return (
    <div className="det-section">
      <div className="det-section__head">
        <span className="det-section__title">{title}</span>
        {action}
      </div>
      <div className="det-section__body">
        {children}
      </div>
    </div>
  );
}

// ── Timeline ──────────────────────────────────────────────────────────────────

function Timeline({ events = [] }) {
  if (!events.length) {
    return (
      <div className="det-empty">
        <Activity size={20} />
        <p>No timeline events yet</p>
      </div>
    );
  }

  return (
    <div className="det-timeline">
      {events.map((ev, i) => {
        const Icon   = TIMELINE_ICONS[ev.event] || Activity;
        const isLast = i === events.length - 1;
        return (
          <div key={i} className={`det-tl-item ${isLast ? 'det-tl-item--last' : ''}`}>
            <div className="det-tl-item__track">
              <div className="det-tl-item__dot"><Icon size={11} /></div>
              {!isLast && <div className="det-tl-item__line" />}
            </div>
            <div className="det-tl-item__content">
              <div className="det-tl-item__top">
                <span className="det-tl-item__event">{ev.event?.replace(/_/g, ' ')}</span>
                {ev.to_status && (
                  <span className="det-tl-item__arrow">
                    → <span className="det-tl-item__status">{ev.to_status}</span>
                  </span>
                )}
                <span className="det-tl-item__time">{fromNow(ev.timestamp)}</span>
              </div>
              {ev.message && <div className="det-tl-item__msg">{ev.message}</div>}
              <div className="det-tl-item__meta">
                {ev.actor_type && <span className="det-tl-pill">{ev.actor_type}</span>}
                {ev.timestamp  && <span className="det-tl-date">{fmtFull(ev.timestamp)}</span>}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

// ── Responders ────────────────────────────────────────────────────────────────

function Responders({ responders = [] }) {
  if (!responders.length) {
    return (
      <div className="det-empty">
        <Users size={20} />
        <p>No responders assigned</p>
      </div>
    );
  }

  return (
    <div className="det-responders">
      {responders.map((r, i) => (
        <div key={i} className="det-responder-row">
          <div className="det-responder-row__avatar"><User size={15} /></div>
          <div className="det-responder-row__info">
            <div className="det-responder-row__id">{r.user_id || r.responder_id}</div>
            <div className="det-responder-row__meta">
              {r.status && <span className="det-tl-pill">{r.status}</span>}
              {r.responded_at && <span className="det-tl-date">{fmtFull(r.responded_at)}</span>}
            </div>
          </div>
          {r.eta_seconds && (
            <div className="det-responder-row__eta">ETA {Math.round(r.eta_seconds / 60)}m</div>
          )}
        </div>
      ))}
    </div>
  );
}

// ── SLA Strip ─────────────────────────────────────────────────────────────────

function SlaStrip({ sla }) {
  if (!sla) return null;

  const items = [
    { label: 'Response',    val: sla.first_acceptance_seconds, unit: 's' },
    { label: 'On Scene',    val: sla.time_to_scene_seconds,    unit: 's' },
    { label: 'Resolution',  val: sla.time_to_resolve_seconds,  unit: 's' },
    { label: 'Escalations', val: sla.escalation_count,         unit: '' },
  ].filter(i => i.val != null);

  if (!items.length) return null;

  const fmtSecs = (s) => {
    if (s < 60)   return `${s}s`;
    if (s < 3600) return `${Math.round(s / 60)}m`;
    return `${(s / 3600).toFixed(1)}h`;
  };

  return (
    <div className="det-sla-strip">
      {items.map((item, i) => (
        <div key={i} className="det-sla-item">
          <div className="det-sla-item__val">
            {item.unit === 's' ? fmtSecs(item.val) : item.val}
          </div>
          <div className="det-sla-item__label">{item.label}</div>
        </div>
      ))}
      {sla.resolution_met != null && (
        <div className={`det-sla-item det-sla-item--badge ${sla.resolution_met ? 'det-sla-item--met' : 'det-sla-item--missed'}`}>
          <div className="det-sla-item__val">{sla.resolution_met ? '✓ Met' : '✗ Missed'}</div>
          <div className="det-sla-item__label">SLA</div>
        </div>
      )}
    </div>
  );
}

// ── Main page ─────────────────────────────────────────────────────────────────

export function IncidentDetail() {
  const { incidentId } = useParams();
  const navigate       = useNavigate();
  const dispatch       = useDispatch();

  // ── Remove `loading` from selector — Redux list loading is unrelated to
  // whether THIS incident has been resolved. We manage that with local state.
  const { org, incidents } = useSelector(
    (state) => ({
      org:       state.auth.organization,
      incidents: state.dashboard.incidents,
    }),
    shallowEqual
  );

  const [incident, setIncident] = useState(null);
  const [fetching, setFetching] = useState(false);

  // On mount — serve from cache immediately, fetch only if missing
 useEffect(() => {
    // 1. Check cache first
    const fromCache = (incidents || []).find(
        i => String(i.incident_id) === String(incidentId) || String(i._id) === String(incidentId)
    );

    if (fromCache) {
        setIncident(fromCache);
        setFetching(false);
    } else {
        setFetching(true);
        // 2. Fetch from API
        dispatch(actions.fetchAllData('incident', org?.organization_id, { incidentId }))
            .then((response) => {
                /**
                 * If your action returns the data directly (standard in most Sety Redux patterns),
                 * extract it from the nested "incident" key in your JSON response.
                 */
                // console.log(response);
                const incidentData = response?.data?.incident || response?.incident;
                
                if (incidentData) {
                    setIncident(incidentData);
                }
            })
            .catch((err) => {
                console.error("Failed to fetch incident:", err);
            })
            .finally(() => {
                // 3. Kill the loader regardless of success/fail
                setFetching(false);
            });
    }
}, [incidentId, org?.organization_id]);


  // Whenever the incidents list updates, try to resolve the one we need.
  // Runs regardless of `fetching` so cache hits after navigation also work.
  useEffect(() => {
  const found = (incidents || []).find(
    i => String(i.incident_id) === String(incidentId) || String(i._id) === String(incidentId)
  );
  if (found) {
    setIncident(found);
    // We don't necessarily need setFetching(false) here if the .finally() above handles it
  }
}, [incidents, incidentId]);

  // Show spinner only while actively fetching — not when Redux list is loading
  if (fetching || !incident) {
    return (
      <div className="det-loading">
        <RefreshCw size={22} className="det-spin" />
        <span>Loading incident…</span>
      </div>
    );
  }

  const type      = getType(incident);
  const statusCfg = STATUS_CFG[incident.status] || STATUS_CFG.active;
  const StatusIcon = statusCfg.icon;
  const sevCfg    = SEVERITY_CFG[incident.severity] || SEVERITY_CFG.medium;
  const createdAt = getDate(incident);

  const timeline = incident.timeline?.length
    ? incident.timeline
    : (incident.updates || []).map(u => ({
        event:      u.type || 'note_added',
        message:    u.message,
        actor_type: 'user',
        actor_id:   u.user_id,
        timestamp:  u.timestamp,
      }));

  const responders = incident.dispatch_assignments?.length
    ? incident.dispatch_assignments
    : incident.responders || [];

  return (
    <div className="det-page">

      {/* ── Top bar ───────────────────────────────────────────────────── */}
      <div className="det-topbar">
        <button className="det-back" onClick={() => navigate(-1)}>
          <ArrowLeft size={16} /> Incidents
        </button>
        <div className="det-topbar__id">
          <Hash size={13} />
          <span className="det-topbar__id-val">{incident.incident_id || incident._id}</span>
        </div>
        <div className="det-topbar__badges">
          <span className={`det-sev ${sevCfg.cls}`}>{sevCfg.label}</span>
          <span className={`det-sta ${statusCfg.cls}`}>
            <StatusIcon size={11} /> {statusCfg.label}
          </span>
        </div>
      </div>

      {/* ── Hero ──────────────────────────────────────────────────────── */}
      <div className="det-hero">
        <div className="det-hero__icon">{TYPE_ICONS[type] || '📋'}</div>
        <div className="det-hero__text">
          <h1 className="det-hero__title">{incident.title || 'Untitled Incident'}</h1>
          <div className="det-hero__meta">
            <span className="det-hero__type">{type.replace(/_/g, ' ')}</span>
            <span className="det-hero__dot" />
            <span className="det-hero__time">Reported {fromNow(createdAt)}</span>
            {incident.is_drill && (
              <><span className="det-hero__dot" /><span className="det-drill-badge">DRILL</span></>
            )}
          </div>
          {incident.description && (
            <p className="det-hero__desc">{incident.description}</p>
          )}
        </div>
      </div>

      {/* ── SLA strip ─────────────────────────────────────────────────── */}
      <SlaStrip sla={incident.sla} />

      {/* ── Body grid ─────────────────────────────────────────────────── */}
      <div className="det-grid">

        {/* Left column */}
        <div className="det-col">

          <Section title="Incident Details">
            <div className="det-meta-grid">
              <MetaItem icon={Calendar}    label="Reported"  value={fmtFull(createdAt)} />
              <MetaItem icon={Tag}         label="Category"  value={type.replace(/_/g, ' ')} />
              <MetaItem icon={Shield}      label="Severity"  value={incident.severity?.toUpperCase()} />
              <MetaItem icon={Activity}    label="Status"    value={statusCfg.label} />
              {incident.resolved_at && (
                <MetaItem icon={CheckCircle} label="Resolved At"  value={fmtFull(incident.resolved_at)} highlight />
              )}
              {incident.cancelled_at && (
                <MetaItem icon={XCircle}     label="Cancelled At" value={fmtFull(incident.cancelled_at)} />
              )}
              {incident.resolution_outcome && (
                <MetaItem icon={FileText} label="Outcome" value={incident.resolution_outcome.replace(/_/g, ' ')} />
              )}
            </div>
            {incident.resolution_notes && (
              <div className="det-notes">
                <div className="det-notes__label">Resolution Notes</div>
                <div className="det-notes__body">{incident.resolution_notes}</div>
              </div>
            )}
          </Section>

          {(incident.subject || incident.reporter || incident.reported_by) && (
            <Section title={incident.subject ? 'Subject' : 'Reporter'}>
              <div className="det-meta-grid">
                {incident.subject ? (
                  <>
                    <MetaItem icon={User}  label="Name"      value={incident.subject.name} />
                    <MetaItem icon={Phone} label="Phone"     value={incident.subject.phone} />
                    <MetaItem icon={Hash}  label="Reference" value={incident.subject.reference} />
                  </>
                ) : incident.reporter ? (
                  <>
                    <MetaItem icon={User}  label="Name"  value={incident.reporter.name} />
                    <MetaItem icon={Phone} label="Phone" value={incident.reporter.phone} />
                    <MetaItem icon={Hash}  label="Email" value={incident.reporter.email} />
                  </>
                ) : (
                  <MetaItem icon={User} label="Reporter" value={
                    incident.reported_by === 'anonymous' ? 'Anonymous' : incident.reported_by
                  } />
                )}
              </div>
              {incident.subject?.metadata && Object.keys(incident.subject.metadata).length > 0 && (
                <div className="det-kv-list">
                  {Object.entries(incident.subject.metadata).map(([k, v]) => (
                    <div key={k} className="det-kv-row">
                      <span className="det-kv-row__key">{k.replace(/_/g, ' ')}</span>
                      <span className="det-kv-row__val">{v}</span>
                    </div>
                  ))}
                </div>
              )}
              {incident.reporter?.phone && (
                <a href={`tel:${incident.reporter.phone}`} className="det-map-link" style={{ marginTop: 12 }}>
                  <Phone size={12} /> Call {incident.reporter.name || 'Reporter'} →
                </a>
              )}
            </Section>
          )}

          {incident.location && (
            <Section title="Location">
              <div className="det-meta-grid">
                <MetaItem icon={MapPin}     label="Address"  value={incident.location.address} />
                <MetaItem icon={Navigation} label="Landmark" value={incident.location.landmark} />
                {incident.location.coordinates?.length === 2 && (
                  <MetaItem
                    icon={MapPin}
                    label="Coordinates"
                    value={`${incident.location.coordinates[1].toFixed(6)}, ${incident.location.coordinates[0].toFixed(6)}`}
                  />
                )}
              </div>
              {incident.location.coordinates?.length === 2 && (
                <a
                  className="det-map-link"
                  href={`https://www.google.com/maps?q=${incident.location.coordinates[1]},${incident.location.coordinates[0]}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <MapPin size={12} /> Open in Google Maps <ChevronRight size={12} />
                </a>
              )}
            </Section>
          )}

        </div>

        {/* Right column */}
        <div className="det-col">

          <Section title="Timeline">
            <Timeline events={timeline} />
          </Section>

          {responders.length > 0 && (
            <Section title={incident.dispatch_assignments?.length ? 'Dispatch Assignments' : 'Responders'}>
              <Responders responders={responders} />
            </Section>
          )}

        </div>
      </div>
    </div>
  );
}